import React, { useContext } from 'react';
import classNames from 'classnames';
import { first } from 'lodash';

import Button from '../../../components/buttons/Button';
import Icon from '../../../components/icons/Icon';
import TemplateButton from './BoardTemplatePickerBodyListingTemplateButton';
import { boardTemplatePickerContext } from '../context/boardTemplatePickerContext';
import useAutoSelectTemplate from '../hooks/useAutoSelectTemplate';

import { getTemplateId, getTemplateIsCustom, EMPTY_BOARD_TEMPLATE } from '../boardTemplatePickerUtil';

import { DefaultTemplate, NavigationLevel } from '../templateTypes';

import './BoardTemplatePickerBodyDefault.scss';

type Props = {
    className?: string;
    defaultTemplateListing: DefaultTemplate[];
    shouldAutoSelectTemplate: boolean;
};

const BoardTemplatePickerDefault = ({ className, defaultTemplateListing, shouldAutoSelectTemplate }: Props) => {
    const { templates, selectedTemplateId, selectTemplate, setNavigation } = useContext(boardTemplatePickerContext);

    useAutoSelectTemplate({ enabled: shouldAutoSelectTemplate, fallbackTemplate: first(defaultTemplateListing) });

    return (
        <div className={classNames('BoardTemplatePickerDefault', className)} data-scrollable={true}>
            <ul className="picker-templates">
                <li>
                    <TemplateButton
                        templateEntry={EMPTY_BOARD_TEMPLATE}
                        templates={templates}
                        selectedTemplateId={selectedTemplateId}
                        selectTemplate={selectTemplate}
                    />
                </li>
            </ul>

            <ul className="picker-templates">
                {defaultTemplateListing.map((templateEntry, index) => (
                    <li key={getTemplateId(templateEntry)}>
                        <TemplateButton
                            templateEntry={templateEntry}
                            templates={templates}
                            isTopPick={index === 0}
                            isCustomTemplate={getTemplateIsCustom(templateEntry)}
                            selectedTemplateId={selectedTemplateId}
                            selectTemplate={selectTemplate}
                        />
                    </li>
                ))}
            </ul>

            <Button
                className="picker-more-button"
                onClickFn={() => setNavigation({ level: NavigationLevel.CATEGORIES })}
            >
                <span>More templates...</span>
                <Icon name="chevron-left" />
            </Button>
        </div>
    );
};

export default BoardTemplatePickerDefault;
